import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(({ breakpoints: BP }) => ({
  pageContent: {
    display: 'flex',
  },
  content: {
    minWidth: '96.5%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    margin: '0 20px',
    overflow: 'auto',
    transition: 'all ease 0.3s',
  },
  profileTabs: {
    background: '#ffffff',
    margin: '0 20px',
    padding: '10px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    justifyContent: 'space-between',
    borderRadius: '5px',
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    '@media (max-width:763px)': {
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },
  containerActions: {
    display: 'flex',
    alignItems: 'cneter',
    justifyContent: 'space-between',
  },
  containerRowRound: {
    overflow: 'hidden',
    width: '100%',
    minWidth: 160,
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    borderRadius: 5,
    backgroundColor: '#d7d7d7',
    fontFamily: 'Averta Light',
    fontSize: 15,
    fontWeight: 300,
    lineHeight: 1.27,
    color: '#9f9f9f',
    cursor: 'pointer',
    ['@media (max-width:450px)']: {
      marginLeft: 0,
      marginTop: 5,
      width: '100%',
    },
  },
  chassisText: {
    textAlign: 'center',
    display: 'flex',
    color: '#000',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    padding: 5,
    flex: '1',
    border: '1px solid #ffffff',
    '&:hover': {
      background: '#edecec',
    },
    '&:first-child': {
      borderRadius: '5px 0 0 5px',
    },
    '&:last-child': {
      borderRadius: '0 5px 5px 0',
    },
  },
  activeChassis: {
    backgroundColor: '#f8b100 !important',
    color: '#000 !important',
    '&:hover': {
      background: '#ffd616 !important',
    },
  },
  select: {
    width: '100%',
    fontFamily: 'Averta Light',
    '& > div': {
      // border: 'solid 1px #707070',
    },
    '& > div:first-child > div': {
      padding: '0 0 0 10px',
    },
    '& svg': {
      fill: '#f8b100',
    },
  },

  selectSchedulerCompany: {
    width: '100%',
    fontFamily: 'Averta Light',
    fontSize: '13px !important',
    '& > div': {
      // border: 'solid 1px #707070',
    },
    '& > div:first-child > div': {
      padding: '0 0 0 10px',
    },
    '& svg': {
      fill: '#f8b100',
    },
  },

  selectSchedulerTimeType: {
    width: '162px',
    marginLeft: 29,
    fontFamily: 'Averta Light',
    fontSize: '13px !important',
    '& > div': {
      // border: 'solid 1px #707070',
    },
    '& > div:first-child > div': {
      padding: '0 0 0 10px',
    },
    '& svg': {
      fill: '#f8b100',
    },
  },

  profileTabsBtn: {
    border: '1px solid #e5e5e5',
    color: '#777575',
    background: '#e5e5e5',
    width: 100,
  },
  activeProfileTabsBtn: {
    background: '#f8b100',
    border: '1px solid #f8b100',
    color: '#ffffff',
    width: 100,
    '&:hover': {
      background: '#f8b100',
    },
  },
  profileBtnsSpan: {
    display: 'flex',
    gap: '10px',
  },
  cardHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '20px 0',
    [BP.down('sm')]: {
      flexDirection: 'column',
      margin: '10px',
    },
  },
  card: {
    padding: '12px 20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    borderRadius: 5,
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    margin: 20,
    marginRight: '4px',
  },
  popupCardScheduler: {
    position: 'relative',
    padding: '15px 15px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 5,
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    maxHeight: '75%',
    maxWidth: '80%',
    animation: 'zoomIn 0.7s',
    minHeight: 600,
    height: 600,
    width: 850,
    justifyContent: 'flex-start',
    overflow: 'unset',
  },

  sslTr: {
    display: 'flex',
    alignContent: 'center',
    flexDirection: 'row',
    borderBottom: '1px solid #dedede',
    alignItems: 'center',
    height: '100%',
    marginRight: '-2px',
  },
  sizeSpan: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    // borderLeft: "1px solid #d2d2d2",
    // boxShadow: '0 0 1px 1px #e9e9e9',
  },
  shiftStatus: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    padding: '0px',
    height: '100%',
    marginBottom: '-0px',
    borderLeft: '1px solid #e9e9e9',
    borderRight: '1px solid transparent',
  },

  list: {
    margin: '20px 0 0px',
    width: '100%',
    minWidth: 800,
    padding: '5px 0',
  },
  listNewAppts: {
    margin: '20px 0 0px',
    width: '100%',
    minWidth: 1300,
    padding: '5px 0',
  },
  listPerDiam: {
    margin: '20px 0 0px',
    width: '100%',
    minWidth: 1500,
    padding: '5px 0',
  },
  listPriority: {
    margin: '20px 0 0px',
    width: '100%',
    minWidth: '100%',
    padding: '5px 0',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    [BP.down('sm')]: {
      marginTop: 15,
      marginBottom: 10,
    },
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 15,
    marginBottom: 15,
    ['@media (max-width:1440px)']: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    ['@media (max-width:1440px)']: {
      marginTop: 10,
    },
  },
  row2: {
    display: 'flex',
    flexDirection: 'row',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontFamily: 'Averta Bold',
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: 1,
    color: '#303030',
  },
  tabsRow: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
  },
  titleView: {
    fontFamily: 'Averta Bold',
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: 1,
    color: '#303030',
    padding: 13,
    marginLeft: 16,
  },

  titleBlue: {
    fontFamily: 'Averta Bold',
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: 1,
    color: '#007fff',
    margin: '0 20px 0 10px',
    cursor: 'pointer',
  },

  import: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 10,
    cursor: 'pointer',
    fontFamily: 'Averta Bold',
    fontWeight: 'bold',
    fontSize: 24,
    lineHeight: 1,
    color: '#44a570',
    '& > svg': {
      height: 28,
      width: 28,
    },
  },
  icon: {
    padding: '0 !important',
    margin: '-7px 0px',
  },
  printIcon: {
    height: 28,
    width: 28,
    fill: '#007fff',
    marginLeft: 10,
    cursor: 'pointer',
  },
  // select: {
  //   width: '100%',
  //   fontFamily: 'Averta Light',
  //   '& > div': {
  //     // border: 'solid 1px #707070',
  //   },
  //   '& > div:first-child > div': {
  //     padding: '0 0 0 10px',
  //   },
  //   '& svg': {
  //     fill: '#f8b100',
  //   },
  // },
  date: {
    boxSizing: 'border-box',
    width: '100%',
    height: 38,
    backgroundColor: '#fff',
    borderRadius: 4,
    justifyContent: 'center',
    fontFamily: 'Averta Light',
    // border: 'solid 1px #707070',
    padding: '0 10px',
    '& input': {
      width: '100%',
      padding: 0,
      cursor: 'pointer',
      fontFamily: 'Averta Light',
    },
    '& svg': {
      fill: '#f8b100',
    },
    '& button': {
      padding: 8,
    },
  },
  loc: {
    '& svg': {
      fill: '#f8b100',
    },

    fontFamily: 'Averta Light',
    width: '100%',
    height: 38,
    backgroundColor: '#fff',
    borderRadius: 5,
    justifyContent: 'center',
    '& input': {
      padding: '5px 10px',
      fontFamily: 'Averta Light',
    },
    '& > div': {
      border: 'solid 1px #707070',
    },
  },
  ml15: {
    marginLeft: 15,
  },
  input: {
    fontFamily: 'Averta Light',
    width: '100%',
    height: 38,
    backgroundColor: '#fff',
    borderRadius: 5,
    justifyContent: 'center',
    border: 'solid 1px #707070',
    '& input': {
      padding: '5px 10px',
      fontFamily: 'Averta Light',
    },
  },
  text: {
    fontFamily: 'Averta Light',
    fontSize: 13,
    fontWeight: 300,
    lineHeight: 1.5,
    color: '#303030',
  },
  but: {
    width: 77,
    height: 27,
    borderRadius: 5,
    backgroundColor: '#f8b100',
    fontFamily: 'Averta Light',
    fontSize: 12,
    fontWeight: 300,
    color: '#fff',
    padding: 0,
  },
  red: {
    backgroundColor: '#e4464b !important',
  },
  blue: {
    backgroundColor: '#007fff !important',
    marginLeft: 10,
  },
  rowRound: {
    width: 180,
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    borderRadius: 20,
    backgroundColor: '#fff',
    fontFamily: 'Averta Light',
    fontSize: 15,
    fontWeight: 300,
    lineHeight: 1.27,
    color: '#9f9f9f',
    marginLeft: 25,
  },
  text2: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease-in',
  },

  tableRow: {
    minWidth: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // height: 60,
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#fff',
    fontFamily: 'Averta Light',
    fontSize: 12,
    fontWeight: 300,
    color: '#43424b',
    textAlign: 'center',

    [BP.up('lg')]: {
      fontSize: 12,
    },
    '& div': {
      whiteSpace: 'nowrap',
      // padding: 5,
    },
  },
  tableRowPierDiam: {
    minWidth: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#fff',
    fontFamily: 'Averta Light',
    fontSize: 12,
    fontWeight: 300,
    color: '#43424b',
    textAlign: 'center',
    [BP.up('lg')]: {
      fontSize: 12,
    },
    '& div': {
      whiteSpace: 'nowrap',
      padding: 5,
    },
  },
  modal: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalBox: {
    width: '400px',
    minHeight: '397px',
    background: '#FFFFFF',
    borderRadius: '5px',
    padding: '10px 15px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  popup: {
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: '#000000aa',
    // zIndex: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '99999999999999999999999999999',
  },
  popupCard: {
    position: 'relative',
    padding: '15px 15px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 5,
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    maxHeight: '75%',
    maxWidth: '80%',
    animation: 'zoomIn 0.7s',
    height: 220,
    width: 400,
    justifyContent: 'flex-start',
    overflow: 'unset',
  },
  tableTopActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 10px',
    gap: 10,
    fontSize: 14,
    borderBottom: '1px solid #E1E4EA',
    marginBottom: 15,
    // fontSize: '18px',
    fontWeight: 900,
    paddingBottom: 8,
  },
  selectOrAddMsgSpan: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  AddSchedulerpopupCard: {
    position: 'relative',
    padding: '15px 15px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 5,
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    maxWidth: '80%',
    animation: 'zoomIn 0.7s',
    height: 'max-content',
    width: 800,
    minHeight: 550,
    justifyContent: 'flex-start',
    overflow: 'unset',
  },
  popupBody: {
    display: 'flex',
    minHeight: '520px',
    gap: '10px',
  },
  schedulerSection: {
    width: '30%',
    border: '1px solid red',
    padding: '10px',
  },
  addSection: {
    width: '65%',
    border: '1px solid blue',
    padding: '10px',
  },
  containerScheduler: {
    display: 'flex',
    gap: '10px',
    minHeight: 550,
    overflowX: 'auto',
    // width: '652px',
    // margin: '50px auto',
    // padding: '20px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },

  containerSchedulerLeft: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '30%',
    minWidth: 175,
    // margin: '50px auto',
    padding: '0px 0px 10px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    border: '1px solid #c8c8c8',
  },
  containerSchedulerRight: {
    width: '65%',
    minWidth: 500,
    // margin: '50px auto',
    padding: '20px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    border: '1px solid #c8c8c8',
  },
  headerScheduler: {
    textAlign: 'center',
    borderBottom: '1px solid #dbdbdb',
    width: '-webkit-fill-available',
    display: 'flex',
    padding: '12px 12px',
    '&:hover': {
      background: '#ececec',
      cursor: 'pointer',
    },
  },
  selectedHeaderScheduler: {
    textAlign: 'center',
    borderBottom: '1px solid #dbdbdb',
    width: '-webkit-fill-available',
    display: 'flex',
    padding: '12px 12px',
    background: '#d3d3d3',
    '&:hover': {
      background: '#ececec',
      cursor: 'pointer',
    },
  },
  schedulerHeader: {
    marginBottom: '0px',
  },
  labelScheduler: {
    display: 'block',
    margin: '8px 0',
    minWidth: 'max-content',
    fontSize: '13px',
  },
  labelSchedulerUser: {
    display: 'block',
    margin: '8px 0',
    minWidth: '65px',
    fontSize: '13px !important',
  },
  labelRepeatScheduler: {
    display: 'block',
    margin: '8px 0',
    minWidth: '98px',
    fontSize: '13px',
  },
  inputScheduler: {
    width: '100%',
    padding: '10px',
    // marginBottom: '12px',
    border: '1px solid #ccc',
    borderRadius: '4px',
  },
  inputTimeScheduler: {
    '& input': {
      width: '161px',
      height: '36px',
      border: '1px solid #cccccc',
    },
  },
  checkboxScheduler: {
    width: 'auto',
  },
  userAccount: {
    padding: '5px 40px 6px',
    display: 'flex',
    gap: '10px',
    flexDirection: 'column',
  },
  numberInputScheduler: {
    width: '135px',
    padding: '8px',
    marginRight: '8px',
    border: '1px solid #ccc',
    borderRadius: '4px',
  },
  repeatTime: {
    display: 'flex',
    gap: 20,
  },
  daysOfWeek: {
    marginBottom: '0px',
  },
  dayButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '8px',
  },
  dayButton: {
    padding: '8px 16px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    width: '59px',
  },
  activeDayButton: {
    padding: '8px 16px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    backgroundColor: '#4caf50',
    color: 'white',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    width: '59px',
  },
  schedulerActions: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px',
  },
  addRemoveBtn: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '29.3%',
    minWidth: 190,
  },
  actionButton: {
    padding: '10px 20px',
    backgroundColor: '#ffb74d',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    height: 35,
    width: 90,
    '&:hover': {
      background: '#f8b100',
    },
  },
  saveButton: {
    padding: '4px 6px',
    backgroundColor: '#4caf50',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    height: 35,
    width: 105,
    '&:hover': {
      background: '#328735',
    },
  },

  fStatus: {
    justifyContent: 'flex-start !important',
    gap: 5,
    alignItems: 'center',
    padding: '0px 5px',
    textAlign: 'center',
    display: 'inline-block !important',
    overflow: 'hidden',
    width: '190px !important',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },

  scrapingSpan: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  contentWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '17px',
    flexDirection: 'column',
  },
  NameSchedulerSection: {
    width: '-webkit-fill-available',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
  },
  userSchedulerSection: {
    width: '-webkit-fill-available',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #c8c8c8',
    padding: '0px 10px 15px',
    borderRadius: 8,
  },
  userCredsSpan: {
    display: 'flex',
    gap: 30,
  },
  repeatSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  deySelectSection: {
    width: '-webkit-fill-available',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #c8c8c8',
    padding: '0px 10px 15px',
    borderRadius: 8,
  },

  pTitle: { color: '#727272' },
  saveBtn: {
    color: '#ffffff',
    background: '#44a570',
    padding: 5,
    marginTop: '10px',
    margin: '2px',
    width: '95px',
    lineHeight: '1.3rem',
    '&:hover': {
      background: '#44a570',
      color: '#ffffff',
    },
  },
  msgPopupBtns: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  containerBadgePopup: {
    background: '#e5e5e5',
    height: '100%',
    display: 'flex',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    padding: '0 14px',
    whiteSpace: 'nowrap',
    minWidth: '50px',
  },

  thead: {
    display: 'flex',
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.2,
    color: '#43424b',
    background: '#f6f6f6',
    textAlign: 'center',
    alignItems: 'center',
    boxShadow: '0px 0px 5px 0 rgba(0, 0, 0, 0.2)',
    [BP.up('lg')]: {
      fontSize: 13,
    },
    '& div': {
      whiteSpace: 'nowrap',
    },
  },
  resText: {
    color: '#007fff',
  },
  bigText: {
    lineHeight: 2.7,
    color: '#303030',
  },
  bold: {
    fontFamily: 'Averta Bold',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 3.86,
    color: '#43424b',
  },
  editIcon: {
    height: 20,
    width: 20,
    fill: '#f8b100',
    [BP.up('lg')]: {
      height: 25,
      width: 25,
    },
  },
  replyIcon: {
    height: 20,
    width: 20,
    fill: '#000000',
    [BP.up('lg')]: {
      height: 25,
      width: 25,
    },
  },
  delIcon: {
    height: 20,
    width: 20,
    fill: '#e4464b',
    [BP.up('lg')]: {
      height: 25,
      width: 25,
    },
  },
  loading: {
    height: '100%',
    margin: 0,
  },
  closeP: {
    position: 'absolute',
    top: 10,
    right: 15,
    height: 25,
    cursor: 'pointer',
    fill: '#e4464b',
  },

  tabActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  selectBox: {
    width: '95px',
    color: '#43424b',
    fontFamily: 'Averta Light',
    fontSize: '14px',
  },

  listContainer: {
    overflow: 'auto',
    width: '100%',
    minHeight: '60vh',
    boxSizing: 'border-box',
    transition: 'all ease 0.3s',
    '&::-webkit-scrollbar-track': {
      transition: 'all 1s ease',
      background: '#bebebe',
    },
    '&::-webkit-scrollbar-thumb': {
      transition: 'all 1s ease',
      borderRadius: '3px',
      background: '#494949',
    },
    '&::-webkit-scrollbar': {
      transition: 'all 1s ease',
      width: '8px',
    },
    // '&:hover': {
    //   transition: 'all 1s ease',
    //   '&::-webkit-scrollbar-track': {
    //     background: '#bebebe',
    //   },
    //   '&::-webkit-scrollbar-thumb': {
    //     borderRadius: '3px',
    //     background: '#494949',
    //   },
    // },
  },
  checkbox: {
    '& svg': {
      fill: '#f8b100',
    },
    '& hover': {
      background: '#f8b1001a',
    },
  },
  textInput: {
    fontFamily: 'Averta Light',
    width: '100%',
    height: 38,
    backgroundColor: '#fff',
    borderRadius: 5,
    justifyContent: 'center',
    border: 'solid 1px #707070',
    marginTop: 5,
    '& input': {
      padding: '5px 10px',
      fontFamily: 'Averta Light',
    },
  },
  modal: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  ShareEmail: {
    color: '#ffffff',
    background: '#007fff',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      color: '#ffffff',
      background: '#007fff',
    },
  },
  suggestionsContainer: {
    borderBottom: '1px solid rgb(218,220,224)',
    paddingBottom: '10px',
  },
  copyActions: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    gap: '6px',
    '& button': {
      padding: 6,
    },
  },
  copySection: {
    flexDirection: 'column',
    borderRadius: '4px',
    background: '#d5d5d5',
    color: '#000000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '6px 10px',
    '& div': {
      flex: '1',
      paddingLeft: '10px',
    },
  },
  shareLinkContainer: {
    flex: '1',
  },
  modalBox: {
    width: '400px',
    minHeight: '397px',
    background: '#FFFFFF',
    borderRadius: '5px',
    padding: '10px 15px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  shareLinkBox: {
    position: 'fixed',
    bottom: 15,
    left: 15,
    minHeight: '250px !important',
    zIndex: '9999',
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
  },
  containersTableContainer: {
    maxHeight: '300px',
    overflow: 'auto',
    flex: '1',
  },
  closeModal: {
    textAlign: 'end',
    '& img': {
      width: '10px',
      height: '10px',
      cursor: 'pointer',
    },
  },
  modalTitle: {
    fontWeight: 'bold',
    fontSize: '20px',
    lineHeight: '23px',
    color: '#000000',
    margin: '0 0 20px 0',
  },
  editContainerInput: {
    background: 'transparent',
    padding: '4px 2px 5px 8px',
    borderRadius: '5px',
    border: '1px solid black',
  },
  updateContainersBtnSpan: {
    display: 'flex',
    justifyContent: 'space-between',
    justifyContent: 'flex-end',
  },
  updateContainersBtnClose: {
    background: '#007fff',
    borderRadius: '5px',
    border: 'none',
    color: '#ffffff',
    fontSize: '13px',
    padding: '10px 15px',
    margin: '15px',
    display: 'block',
  },
  updateContainersBtnSave: {
    background: '#3c845d',
    borderRadius: '5px',
    border: 'none',
    color: '#ffffff',
    fontSize: '13px',
    padding: '10px 15px',
    margin: '15px',
    display: 'block',
  },
  containerTable: {
    width: '100%',
    '& tr': {
      display: 'flex',
    },
    '& th': {
      color: '#777575',
      fontSize: '13px',
      padding: '10px',
    },
    '& td': {
      padding: '0 10px',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#000000',
      fontSize: '13px',
      height: '27px',
      borderBottom: '1px solid #dedede',
      '& label': {
        margin: 0,
      },
      '& svg': {
        fill: '#000000',
      },
    },
  },
  containerChecBox: {
    accentColor: '#000000',
  },
  chassisNameContainer: {
    display: 'flex',
    alignItems: 'center',
    '& img': {
      width: 25,
      height: 25,
      margin: '0 10px',
    },
  },

  inviteIconContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '8px 0',
    borderBottom: '1px solid rgb(218,220,224)',
  },
  inviteIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontWeight: 'bold',
    borderBottom: '2px solid #007fff',
    padding: '10px 6px',
    color: '#007fff',
  },
  email: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  removeEmail: {
    width: 28,
    height: 28,
  },
  emailInputContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 5,
    borderBottom: '1px solid rgb(218,220,224)',
    paddingBottom: '8px',
    '& input': {
      flex: '1',
    },
  },
  emailBadge: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid rgb(218,220,224)',
    padding: '1.5px',
    borderRadius: '16px',
    gap: 6,
    width: 'fit-content',
  },
  emailAvatar: {
    width: 28,
    height: 28,
  },
  removeEmailIcon: {
    width: '1rem',
  },
  suggestion: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '3px 0',
  },
  suggestionInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  suggestionAvatar: {
    width: 30,
    height: 30,
  },
  emailCheckBox: {
    '& svg': {
      fill: '#007fff',
    },
    '& hover': {
      background: '#007fff45',
    },
  },
  shifttd: {
    display: 'flex',
    justifyContent: 'space-evenly',
    borderLeft: '1px solid #e9e9e9',
    borderRight: '1px solid #e9e9e9',
    height: 61,
    alignItems: 'center',
  },
  shifttdReload: {
    display: 'flex',
    justifyContent: 'space-evenly',
    borderLeft: '1px solid #e9e9e9',
    borderRight: '1px solid #e9e9e9',
    height: 61,
    alignItems: 'center',
    '&:hover': {
      background: '#e5e5e5',
      cursor: 'pointer',
    },
  },
  shifttdNull: {
    display: 'flex',
    background: '#fafafa',
    justifyContent: 'space-evenly',
    borderLeft: '1px solid #e9e9e9',
    borderRight: '1px solid #e9e9e9',
    height: 61,
    alignItems: 'center',
  },

  shifttdClick: {
    display: 'flex',
    justifyContent: 'space-evenly',
    borderLeft: '1px solid #e9e9e9',
    borderRight: '1px solid #e9e9e9',
    height: 61,
    alignItems: 'center',
    '&:hover': {
      background: '#f7f7f7',
      cursor: 'pointer',
    },
  },
  tableTopMargin: {
    marginTop: 60,
  },
  fix: {
    background: '#eaeaea',
    position: 'fixed',
    top: 65,
    zIndex: '1',
    overflowY: 'hidden' /* Hide vertical scrollbar */,
    overflowX: 'auto' /* Hide horizontal scrollbar */,
    scrollbarWidth: 'none',
    boxShadow: '0 0 8px 0px #00000066',
  },
  shifttdToday: {
    background: '#f5f5f5',
    display: 'flex',
    justifyContent: 'space-evenly',
    borderLeft: '1px solid #e9e9e9',
    borderRight: '1px solid #e9e9e9',
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.2)',
    height: 61,
    alignItems: 'center',
  },
  tableTopMargin: {
    marginTop: 70,
  },
  terminalLink: {
    display: 'flex',
    flexDirection: 'column',
    textDecoration: 'auto',
    color: '#43424b',
  },

  containerInput: {
    display: 'flex',
    alignItems: 'center',
    // overflow: 'hidden',
  },
  containerBadge: {
    background: '#e5e5e5',
    height: '100%',
    display: 'flex',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    padding: '0 14px',
    whiteSpace: 'nowrap',
    width: '50px',
    minWidth: '50px',
  },
  input: {
    fontFamily: 'Averta Light',
    width: '100%',
    height: 38,
    backgroundColor: '#fff',
    borderRadius: 5,
    border: 'solid 1px #707070',
    '& input': {
      fontFamily: 'Averta Light',
      padding: '5px 10px',
    },
  },
  fix: {
    background: '#f0f0f0',
    position: 'fixed',
    top: 65,
    zIndex: '1',
    overflowY: 'hidden' /* Hide vertical scrollbar */,
    overflowX: 'auto' /* Hide horizontal scrollbar */,
    scrollbarWidth: 'none',
    boxShadow: '0 0 8px 0px #00000066',
  },

  thdate: {
    display: 'flex',
    justifyContent: 'center',
    height: 60,
    alignItems: 'center',
  },
  open: {
    background: '#0080001f',
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    borderRadius: '8px',
    padding: '5px 11px',
    margin: '18px 0px',
    justifyContent: 'center',
    fontSize: 9,
  },
  close: {
    background: '#ff00001c',
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    borderRadius: '8px',
    padding: '5px 8px',
    margin: '18px 0px',
    justifyContent: 'center',
    fontSize: 9,
  },
  dual: {
    background: '#ffa82738',
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    borderRadius: '8px',
    padding: '5px 13px',
    margin: '18px 0px',
    justifyContent: 'center',
    fontSize: 9,
  },
  nullStatus: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    borderRadius: '8px',
    padding: '5px 13px',
    margin: '18px 0px',
    justifyContent: 'center',
  },
  nullStatusAdmin: {
    minWidth: 21,
    minHeight: 12,
    background: '#e2e2e2b0',
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    borderRadius: '8px',
    padding: '5px 11px',
    margin: '18px 0px',
    justifyContent: 'center',
    fontSize: 9,
  },

  tableTh: {
    height: '-webkit-fill-available',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '40px',
    // border: "1px solid #afafaf",
    borderBottom: 'none',
    borderTop: 'none',
    justifyContent: 'center',
  },
  tableDateShowToday: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  tableDateShow: {
    display: 'flex',
    color: '#a1a1a1',
    flexDirection: 'column',
    padding: '8px 12px 8px !important',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    fontSize: '12px',
    gap: 1,
  },
  terminalsNameLogo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  dayName: {
    color: '#a1a1a1',
  },
  dayNameToday: {
    color: '#f8b100',
  },
  dayNumberNormal: {
    fontSize: 19,
    padding: '7px 9px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dayNumberToday: {
    minWidth: 19,
    fontSize: 19,
    padding: '7px 9px',
    background: '#f8b100',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
  },
  find: {
    width: 133,
    height: 40.3,
    borderRadius: 5,
    backgroundColor: '#f8b100',
    fontFamily: 'Averta Bold',
    fontSize: 21,
    fontWeight: 'bold',
    lineHeight: 1.86,
    color: '#303030',
    padding: 0,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#ffd616',
    },
    [BP.down('xs')]: {
      fontSize: '1rem',
      width: '33vw',
      height: 30,
      '& > .MuiButton-label': {
        height: 30,
      },
    },
  },
  findIcon: {
    width: 28,
    height: 40,
    fill: '#303030',
  },
  searchbtn: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  sortingTopTable: {
    '&::after': {
      content: '▲',
    },
  },
  sortingButtomTable: {
    '&::after': {
      content: '▼',
    },
  },
  failDiv: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
  },
  fmessage: {
    width: '50%',
    fontSize: 13,
  },
}));
